import portalAPI from "./portalService";

let pAPI = new portalAPI();

class MessageValidator {
  constructor() {}

  validateMessage(nodeId, msgTypeName, message) {
    // Validate message list of same type
    //let isValid = true;
    let errorMessage = "";
    let that = this;
      pAPI.getMessageSenderSettings(nodeId, msgTypeName).then(res => {
        let msgType = res.data;
        if (msgType.message_item_count > -1) {
          let isValid = message.length == msgType.message_item_count;
          if (!isValid)
            that.errorMessage = `The sent messages exceeded the allowed limits {msgType.message_item_count} messages`;
        }
        message.forEach(messageItem => {
          let validMessageType = that.validateMessageItem(messageItem, msgType);
          //isValid = isValid && validMessageType;
          if (!validMessageType)
            that.errorMessage += `\r\n message {messageItem.name} is not valid`;
        });
      });
    return errorMessage ? errorMessage : true;
  }

  validateMessageItem() {
    //messageItem, msgType) {
    let isValidMessage = true;
    // jsonld.compact(messageItem, msgType.schema, function (err, compacted) {
    //     //console.log(JSON.stringify(compacted, null, 2));
    //     if (err)
    //         isValidMessage = false;

    // });
    return isValidMessage;
  }
}

export default MessageValidator;
